<template>
  <div class="component" id="TerminalBox" ref="TerminalBox">
    <van-collapse :border="false" class="box" v-model="activeNames">
      <van-collapse-item :border="false" name="1">
        <template #title>
          <div class="title">
            <div class="row">
              <van-icon class="icon" name="location" />
              <span>{{ TerminalName }}</span>
            </div>
            <div
              :style="{ color: terminal.Color }"
              class="remark"
              v-html="terminal.Remark"
              v-if="showRemark"
            ></div>
          </div>
        </template>
        <template #default>
          <div class="services">
            <div :key="'s@' + index" class="row" v-for="(item, index) in terminal.detail">
              <div class="title">{{ item.ServiceName }}</div>
              <div class="value">
                <div v-if="item.LocationName && item.LocationName !== ''">
                  <b>网点名称：</b>
                  <div class="content" v-html="item.LocationName"></div>
                </div>
                <div v-if="item.LocExplain && item.LocExplain !== ''">
                  <b>位置说明：</b>
                  <div class="content" v-html="item.LocExplain"></div>
                </div>
                <div v-if="item.ServiceDT && item.ServiceDT !== ''">
                  <b>营业时间：</b>
                  <div class="content" v-html="item.ServiceDT"></div>
                </div>
                <div v-if="item.ServiceExplain && item.ServiceExplain !== ''">
                  <b>服务内容：</b>
                  <div class="content" v-html="item.ServiceExplain"></div>
                </div>
                <div v-if="item.Remark && item.Remark !== ''">
                  <div class="content" v-html="item.Remark"></div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import Vue from "vue";
import { Collapse, CollapseItem } from "vant";
Vue.use(Collapse).use(CollapseItem);
export default {
  name: "TerminalBox",
  filters: {},
  props: {
    terminal: Object,
  },
  data() {
    return {
      activeNames: ["1"],
    };
  },
  computed: {
    showRemark: function () {
      return this.activeNames.includes("1");
    },
    TerminalName: function () {
      let t = this.terminal;
      return t.TerminalName && t.TerminalName != "" ? t.TerminalName : t.AirportTerminalName;
    },
  },
  watch: {},
  mounted() {
    // let that = this;
  },
  methods: {},
};
</script>

<style lang="less">
@import "../main";
#TerminalBox.component {
  .box {
    div {
      background: transparent !important;
    }
    .van-collapse-item__title {
      #bundle.flex-row();
      align-items: center;
      padding: 5px 16px 8px;
      .van-icon-arrow {
        align-self: flex-start;
        color: #bc0e27;
        font-size: 20px;
      }
      .title {
        .row {
          #bundle.flex-row();
          align-items: center;
          font-size: 15px;
          color: #bc0e27;
          font-weight: bold;
          .icon {
            font-size: 22px;
          }
        }
        .remark {
          box-sizing: border-box;
          font-size: 12px;
          padding-left: 24px;
          color: #000000;
          white-space: pre-wrap;
        }
      }
    }
    .van-collapse-item__content {
      #bundle.flex-row();
      justify-content: center;
      align-items: center;
      padding: 0 16px;
      .services {
        .row {
          display: table;
          position: relative;
          width: 325px;
          color: #000000;
          font-size: 12px;
          overflow: hidden;
          box-sizing: border-box;
          border: 1px solid #aaa;
          border-top-width: 0;
          &:first-of-type {
            border-top-width: 1px;
          }
          .title {
            display: table-cell;
            vertical-align: middle;
            box-sizing: border-box;
            padding: 2px;
            width: 100px;
            text-align: center;
            font-weight: bold;
          }
          .value {
            display: table-cell;
            box-sizing: border-box;
            padding: 2px;
            border-left: 1px solid #aaa;
            width: 225px;
            .content {
              display: inline;
              white-space: pre-wrap;
            }
          }
        }
      }
    }
  }
}
</style>
